import * as React from 'react';
import classnames from 'classnames';
import { camelCase, isEmpty, isNil } from 'lodash';

import IconWithPopover from 'components/icon-with-popover/IconWithPopover';

import { getAbbreviatedPriceRecommendationRange } from 'utils/helper/price';
import { PriceRecoItem, getPriceRecoPerTasksTypes } from 'utils/influencers';
import { DELIVERABLE_ICONS } from 'utils/deliverables';
import { isDefined } from 'utils/helper/common';
import { __t, applyTranslations } from 'utils/language';

import './creator-tile-price-reco.scss';

import type { Channel, Channels } from 'types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

type Props = {
  channelsData: Channels | Array<Channel>,
  channels: Array<string>,
  caption?: React.ReactNode,
  captionClassName?: string,
  containerClassName?: string,
  className?: string,
  emptyMessage?: string,
  size?: 'normal' | 'large'
};

class CreatorTilePriceReco extends React.Component<Props> {
  private renderPriceEntry(entry: PriceRecoItem): React.ReactNode {
    const { size } = this.props;

    if (isNil(entry.minPrice) || isNil(entry.maxPrice)) {
      return undefined;
    }

    const priceRangeToRender = getAbbreviatedPriceRecommendationRange(entry.minPrice, entry.maxPrice);
    const entryClassName = classnames('creator-tile-price-reco__entry', {
      'creator-tile-price-reco__entry--size-large': size === 'large'
    });
    const iconClassName = classnames('creator-tile-price-reco__icon', {
      'creator-tile-price-reco__icon--size-large': size === 'large'
    });

    return (
      <div
        key={entry.type}
        className={entryClassName}
      >
        <div
          className={iconClassName}
        >
          <IconWithPopover
            name={`${DELIVERABLE_ICONS[camelCase(entry.type)]}`}
            width={12}
            height={12}
            label={__t(`collabary_common.types.${entry.type}.singular`)}
          />
        </div>
        <div>
          {priceRangeToRender}
        </div>
      </div>
    );
  }

  render() {
    const {
      channelsData,
      channels,
      caption,
      captionClassName,
      containerClassName,
      className,
      emptyMessage
    } = this.props;
    const metrics = channels.flatMap(channel => getPriceRecoPerTasksTypes(channelsData, channel));

    const mappedChannels = metrics.map(this.renderPriceEntry, this).filter(isDefined);

    if (isEmpty(mappedChannels)) {
      return emptyMessage
        ? (<section className={className}>{emptyMessage}</section>)
        : null;
    }

    return (
      <section className={className}>
        {
          caption && (
            <div className={captionClassName}>
              {caption}
            </div>
          )
        }
        <div className={containerClassName ?? 'creator-tile-price-reco__default-container'}>
          {mappedChannels}
        </div>
      </section>
    );
  }
}

export default CreatorTilePriceReco;
